<script lang="ts">
	import type { ConfiguratorState } from '$lib/state/configurator.svelte';
	import type { OrderConfiguratorBlock as OrderConfiguratorBlockType } from '$models/Block/OrderConfiguratorBlock';
	import type { OrderConfigurationOrder } from '$models/OrderConfigurator/OrderConfigurator';
	import { browser } from '$app/environment';
	import OrderConfigurator from '$components/OrderConfigurator/OrderConfigurator.svelte';
	import { trackAddToCart, trackViewItem } from '$lib/datalayer/datalayer';
	import { getCartState } from '$lib/state/cart.svelte';
	import { getDefaultOrderFromConfigurator } from '$lib/utils';
	import { onMount, tick } from 'svelte';

	let { block }: { block: OrderConfiguratorBlockType } = $props();

	const cartState = getCartState();
	let hasTrackedViewItem = false;

	async function submitOrderConfiguratorHandle(
		order: OrderConfigurationOrder,
		configuratorState: ConfiguratorState
	) {
		cartState.setCart(order);
		if (configuratorState.isValid()) {
			trackAddToCart(order);
		} else {
			trackAddToCart(order, configuratorState.baseTotal());
		}

		await tick();

		cartState.open();
	}

	function trackConfiguratorViewItem() {
		if (!browser || hasTrackedViewItem || !block.configurator) {
			return;
		}

		const defaultOrder = getDefaultOrderFromConfigurator(block.configurator);

		trackViewItem(defaultOrder);
		hasTrackedViewItem = true;
	}

	onMount(() => {
		trackConfiguratorViewItem();
	});
</script>

{#if block.configurator}
	<div>
		<OrderConfigurator
			configurator={block.configurator}
			onSubmit={submitOrderConfiguratorHandle}
			recurringCouponCode={block.couponCodeRecurring}
			onetimeCouponCode={block.couponCodeOnetime}
			options={{
				recurringCtaTooltip: block.recurringCtaTooltip
			}}
		/>
	</div>
{/if}
